import React from "react";
import { Link } from "react-router-dom";
import type { IPageMetaAction } from "../../../hooks/pageMetaStore";
import LegacyButton from "../../Atomos/Buttons/LegacyButton";
import PencilEdit from "../../Atomos/Icons/PencilEdit";

type Action = NonNullable<Exclude<IPageMetaAction, null>>;

/** Mobile: full width of the column when stacked; sm+: fixed width to match the pair. */
const TITLE_ACTION_WIDTH_CLASS =
  "!normal-case w-full min-w-0 sm:w-[280px] sm:shrink-0";

/** Member header title actions using LegacyButton + page meta (legacyButtonColor / legacyButtonStyle). */
export function MemberTitleLegacyAction({ action }: { action: Action }) {
  const resolvedIcon =
    (action.icon as JSX.Element | undefined) ?? (
      <PencilEdit className="h-5 w-5 shrink-0" />
    );

  const button = (
    <LegacyButton
      text={action.label}
      icon={resolvedIcon}
      content="textIcon"
      textIconLayout="cluster"
      color={action.legacyButtonColor!}
      style={action.legacyButtonStyle ?? "filled"}
      size="medium"
      className={TITLE_ACTION_WIDTH_CLASS}
    />
  );

  if (action.to) {
    return (
      <Link
        to={action.to}
        className="inline-flex w-full min-w-0 no-underline sm:w-auto"
        target={action.openInNewTab ? "_blank" : undefined}
        rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      >
        {button}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className="inline-flex w-full min-w-0 border-0 bg-transparent p-0 sm:w-auto"
      onClick={() => action.onClick?.()}
    >
      {button}
    </button>
  );
}
